module.exports = __webpack_public_path__ + "static/media/02-cht.27bbd52c.png";